import { getSessionDate } from '@/src/utils/getSessionDate';

export const createGetQuotesRequestHeaders = () => {
  const date = getSessionDate();
  const isProduction = process.env.VERCEL_ENV === 'production';

  const headers = {
    'x-audience-source': '*',
    'x-audience-type': 'OVO_CUSTOMER',
    'Content-Type': 'application/json',
    ...(date && !isProduction && { 'x-date-now': date.toISOString() }),
  };

  return headers;
};
